import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { formMappings } from "../../../../config/formMappings";

export default function MoneyTotalCount() {
  const entries = useSelector((state: RootState) => state.formEntries.entries);

  const activeFormName = useSelector(
    (state: RootState) => state.formEntries.activeFormName || ""
  );

  const formMapping = formMappings[activeFormName as keyof typeof formMappings];
  const totalFieldKey = formMapping?.fieldMappings?.Total || "p2l9j-value";

  // Calculate total revenue (entries already filtered to only paid entries)
  const totalRevenue = entries.reduce((acc, entry) => {
    // Get the total value (check both the field key and mapped name)
    const totalValue = entry.meta[totalFieldKey] || entry.meta["Total"];

    if (totalValue) {
      const value = parseFloat(String(totalValue));
      if (!isNaN(value)) {
        return acc + value;
      }
    }
    return acc;
  }, 0);

  return (
    <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
      <dt className="truncate text-sm font-medium text-gray-500">Revenue</dt>
      <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
        $
        {totalRevenue.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </dd>
    </div>
  );
}
